import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { RootState, selectActiveSession } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'

/**
 * This is needed for requests sent to the backend when no session is actually created yet
 */
export const IGNORE_SESSION_ID = 'ce9c7d02-e5a4-4ff7-9ead-6c8ef9cf2653'
export const SESSION_ID_HEADER = 'helios-session-id'

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (httpRequest.headers.has(SESSION_ID_HEADER)) {
      return next.handle(httpRequest)
    }

    return this.store.select(selectActiveSession).pipe(
      take(1),
      switchMap(session => {
        return session == null
          ? next.handle(
              httpRequest.clone({
                setHeaders: {
                  [SESSION_ID_HEADER]: IGNORE_SESSION_ID,
                  'helios-fake-session-id': 'true',
                },
              }),
            )
          : next.handle(
              httpRequest.clone({
                setHeaders: { [SESSION_ID_HEADER]: session.id },
              }),
            )
      }),
    )
  }

  constructor(private readonly store: Store<RootState>) {}
}
